// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.icon[data-v-62fe346e] {\r\n  width: 1em;\r\n  height: 1em;\r\n  vertical-align: -0.15em;\r\n  fill: currentColor;\r\n  overflow: hidden;\n}\n.footericon[data-v-62fe346e]{\r\n  font-size: 40px;margin-left:10px;margin-right: 5px\n}\n.footertxt[data-v-62fe346e]{\r\n  font-family: 微软雅黑,黑体;font-weight: bold;font-size: 18px\n}\r\n", ""]);
// Exports
module.exports = exports;
